import {
  GET_WORD_PAIR_SUCCESS,
  TOGGLE_SHOW_TRANSLATION,
} from '../constants';

export interface IShowTranslation {
  type: typeof TOGGLE_SHOW_TRANSLATION | typeof GET_WORD_PAIR_SUCCESS;
}

const showTranslation = (state: boolean = false, action: IShowTranslation): boolean => {
  switch (action.type) {
    case GET_WORD_PAIR_SUCCESS:
      return false;

    case TOGGLE_SHOW_TRANSLATION:
      return !state;

    default:
      return state;
  }
};

export default showTranslation;
